// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> dakota-apartments
// Generated: 2026-11-04T23:48:36.049Z
// Counts: 0 design, 39 content, 18 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Room to Relax and Unwind</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Stanley Living at Its Best</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>South Stanley Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Dakota, in Stanley, ND, you'll enjoy everyday conveniences and extras that help you feel at home. Your apartment features a fully equipped kitchen, washer and dryer, walk-in closets, and a private patio or balcony for added comfort. Community spaces include beautiful courtyard views, open guest parking, heated hallways, and a smoke-free atmosphere. Plus, pets are always welcome here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about our apartments or want to start your application? Contact the Dakota leasing team in Stanley, ND. We're here to guide you through the process and help you feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover roomy two-bedroom apartments for rent at Dakota in Stanley, ND. Each home features an open-concept design, spacious walk-in closets for wardrobe and storage, and an in-unit washer and dryer to simplify laundry day. Relax at home in a space ready for your lifestyle, whether you're working from home or hosting friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Thoughtfully designed two-bedroom layouts</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself relaxing at Dakota Apartments, where bright rooms and modern touches welcome you home. Scroll through the gallery and see spacious kitchens ready for your favorite recipes, open living rooms for everyday lounging, and courtyard views that bring a bit of Stanley's charm to your window. See what life could look like in your next home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfy and inviting apartments in lively Stanley, ND</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Dakota, you'll wake up in a spot surrounded by Stanley's best - Wilson Park just down the road, daily essentials at Cash Wise Foods and Dollar General minutes away, and the community dog park calling your pet for playtime. The Stanley Community School District is part of the neighborhood, with Stanley Junior-Senior High School just across the street. Downtown charm, convenient shopping and dining, and Highway 2 all come together right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Dakota puts you steps from Wilson Park, with grocery stops like Cash Wise Foods and Dollar General nearby. Morning coffee, a walk with your pet along winding paths, or a quick errand- everything is close at hand. With Highway 2 less than five minutes away and Stanley Junior-Senior High School across the street, enjoy life in the heart of Stanley, ND.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Stanley, ND? At Dakota, you'll find inviting spaces with in-unit washer and dryer and airy, open layouts where you can create your own retreat. Enjoy the comfort of your home, the ease of free on-site parking, and the warmth of a pet-friendly community that brings people and pets together. Step into a lifestyle where modern touches meet friendly faces every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to see your next apartment? At Dakota, you can schedule a tour that works for you - choose an in-person or virtual option. Our leasing team is here to help you explore the community and answer your questions. Find your new favorite space in Stanley, ND, whether you visit us on-site or from your couch.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Dakota is easy to picture from your laptop or phone. Our virtual tour lets you stroll through the community, get a feel for the spacious layouts, and imagine settling in before you even walk through the front door. Discover how every thoughtfully designed space welcomes you to relaxed living in Stanley, ND.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-db8d-72ae-b4a5-6184ae52becf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept kitchen with island, wood cabinets, white appliances, and a dining table in a carpeted living area."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-f5de-7439-bf67-6ed5709cb542.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living area with beige carpet, a black leather sofa, coffee table, and dining area near the kitchen."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-820e-71cb-87b1-22105d5d4222.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "U-shaped kitchen with wooden cabinets, white refrigerator, stove, dishwasher, and a curved countertop"
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-b066-70bc-9488-fb54e8fecb7a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a modern multi-family apartment building with balconies and stone accents."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-8222-762e-84a1-db1b71ebce9e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept kitchen with island and dining table in a beige, carpeted apartment."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-e995-77bf-8aaa-98806b9cdab5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Three people sit on a blanket on a sunny grassy lawn with a fluffy white dog."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-b91c-77ef-ba41-a8d2c6e0e6ba.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Sidewalk along a grassy courtyard with trees beside an apartment building."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-820e-71cb-87b1-22105d5d4222.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen in an apartment with wooden cabinets, white fridge and stove, double sink, and curved peninsula countertop."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-8e99-71f2-8255-e369b76da50a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a neatly made bed, two nightstands, and an open closet."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-819a-74ac-a6b4-0643c60de0df.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room in an apartment with beige sofa, coffee table, and plants."
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
